import { Link } from "react-router-dom";

const SideBarMenuItem = ({ destinationRoute, childItems=[], listID, faIconClasses, title }) => {
	const itemAttrs = childItems.length? {
		'className': 'nav-link dropdown-indicator',
		'to': '#' + listID,
		'data-bs-toggle': 'collapse',
		'aria-expanded': 'false',
		'aria-controls': listID
	  } : {
		'className': 'nav-link',
		'to': destinationRoute
	  };

	return <>
		<Link {...itemAttrs} role="button">
			<div className="d-flex align-items-center">
				<span className="nav-link-icon">
					<span className={faIconClasses}></span>
				</span>
				<span className="nav-link-text ps-1">{title}</span>
			</div>
		</Link>
		{childItems.length ?
			<ul className="nav collapse" id={listID}>
				{childItems.map(item =>
					<li className="nav-item" key={item.link}>
						<Link className="nav-link" to={item.link}>
							<div className="d-flex align-items-center">
								<span className="nav-link-text ps-1">{item.title}</span>
							</div>
						</Link>
					</li>
				)}
			</ul>
		: ''}
	</>
};

export default SideBarMenuItem;
